import { ROUTE_NAME } from "@/constants/routes-name";
import { lazyWithRetry } from "@/utils/lazy-with-retry";

const EvaluationPage = lazyWithRetry(() => import("../pages/Evaluation"));

export const EVALUATION_ROUTE = {
  id: ROUTE_NAME.EVALUATION,
  path: ROUTE_NAME.EVALUATION,
  Component: EvaluationPage,
};
